// import { AttentionBox } from "Components/AttentionBox";
import { Paragraph } from "../Paragraph";
import React from "react";
import { Section } from "./Section";
import { CategorySetDisplay } from "./types";
import styles from "./Section.module.scss";
import { CategoryContext } from "../Context";

export const CategorySetSectionDisplay: React.FC<CategorySetDisplay> = ({ categories }) => {
    const { CategoryContent } = require("./CategoryContent");

    return (
        <>
            {categories?.map((category, index) => {
                const { faIcon, theme, displayName, description } = category;
                return (
                    <Section
                        //key={tid}
                        key={index}
                        title={displayName}
                        faIcon={faIcon}
                        theme={theme}
                        className={index === categories.length - 1 ? styles.lastSectionInCategorySection : ""}
                    >
                        <CategoryContext.Provider
                            value={{
                                category
                            }}
                        >
                            {description?.processed != null && description.processed.trim() !== "" && (
                                <>
                                    <Paragraph nid={-1} title={""} status={true} text={description} />
                                </>
                            )}
                        </CategoryContext.Provider>

                        <CategoryContent
                            category={category}
                            graphicElementIds={
                                category?.catGraphContent
                                    ?.map(d => d.nid)
                                    ?.filter(d => d != null && d.toString().trim() !== "") ?? []
                            }
                        />
                    </Section>
                );
            })}
        </>
    );
};
